import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const rootElement = document.getElementById("root");

/*
 * Production homepage is prerendered as static HTML.
 * On that page React is only loaded when the visitor opens AI Guide.
 *
 * All other pages continue to run the normal React application.
 */
const isStaticHomeAI =
  typeof window !== "undefined" &&
  window.__KT_STATIC_HOME_AI__ === true;

if (isStaticHomeAI) {
  const aiRootElement = document.getElementById("kt-ai-root");

  if (aiRootElement) {
    const aiRoot = ReactDOM.createRoot(aiRootElement);

    const showTrigger = () => {
      const trigger = document.getElementById("kt-static-ai-trigger");
      if (trigger) {
        trigger.style.display = "block";
      }
    };

    const hideTrigger = () => {
      const trigger = document.getElementById("kt-static-ai-trigger");
      if (trigger) {
        trigger.style.display = "none";
      }
    };

    const openAI = async () => {
      hideTrigger();

      try {
        const { default: AIWidget } = await import("./components/AIWidget");

        aiRoot.render(
          <AIWidget
            visible={true}
            onClose={() => {
              aiRoot.render(null);
              showTrigger();
            }}
          />
        );
      } catch (error) {
        console.error("Failed to load AI Guide:", error);
        showTrigger();
      }
    };

    // Allows reopening the AI without loading main.js again.
    window.__KT_OPEN_AI__ = openAI;

    openAI();
  }
} else if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
